import { createAction, props } from '@ngrx/store';
import { selectionType, SelectMetersState } from './select-meters.interface';
import { IVirtualMeterChildMeter } from '@features/meters/store/meters.interface';

export enum SelectMetersActionType {
  getMeters = '[Select Meters] Get Meters',
  getMetersSuccess = '[Select Meters] Get Meters Success',
  getMetersFailure = '[Select Meters] Get Meters Failure',

  getMeterFilterOptions = '[Select Meters] Get Meter Filter Options',
  getMeterFilterOptionsSuccess = '[Select Meters] Get Meter Filter Options Success',
  getMeterFilterOptionsFailure = '[Select Meters] Get Meter Filter Options Failure',

  setSelectMeterComponentFilters = '[Select Meters] Set Filters',

  setSelectMetersProperties = '[Select Meters] Set Select Meters Service',

  setPagingRequest = '[Select Meters] Set Paging Request',
  setSearchText = '[Select Meters] Set Search Text',

  setSelectUnselectedMetersByGroup = '[Select Meters] Set Select All Meters',

  setSelectedMetersWithFactor = '[Select Meters] Set Selected Meters With Factor',

  setSelectedMeters = '[Select Meters] Set Selected Meters',
  setSelectionType = '[Select Meters] Set Selection Type',
  setSingleSelectedMeter = '[Select Meters] Set Single Selected Meter',
  resetSelectMeters = '[Select Meters] Reset Select Meters',
  updateSelectedMetersSuccess = '[Select Meters] Update Selected Meters Success',
}

export const setSelectMetersProperties = createAction(
  SelectMetersActionType.setSelectMetersProperties,
  props<{
    // serviceId: SelectMetersServiceId;
    propertyData: any | null;
    selectionType: selectionType;
    selectedMeter: any;
    inputLimit: number;
    withFactor?: boolean;
  }>(), // serviceId represents the identifier for service selection
);

export const getMeters = createAction(SelectMetersActionType.getMeters);
export const getMetersSuccess = createAction(
  SelectMetersActionType.getMetersSuccess,
  props<{ meters: any }>(),
);

export const getMetersFailure = createAction(
  SelectMetersActionType.getMetersFailure,
  props<{ error: any }>(),
);

export const setPagingRequest = createAction(
  SelectMetersActionType.setPagingRequest,
  props<{ pageNumber: number }>(), // pagingRequest represents the paging request
);

export const setSearchText = createAction(
  SelectMetersActionType.setSearchText,
  props<{ search: string }>(), // search represents the search text
);

export const setSelectUnselectedMetersByGroup = createAction(
  SelectMetersActionType.setSelectUnselectedMetersByGroup,
);

export const setSelectedMeters = createAction(
  SelectMetersActionType.setSelectedMeters,
  props<{ selectedMeters: any[] }>(),
);

export const resetSelectMeters = createAction(
  SelectMetersActionType.resetSelectMeters,
);

export const updateSelectedMetersSuccess = createAction(
  SelectMetersActionType.updateSelectedMetersSuccess,
);

export const setSelectionType = createAction(
  SelectMetersActionType.setSelectionType,
  props<{ selectionType: selectionType }>(),
);

export const setSingleSelectedMeter = createAction(
  SelectMetersActionType.setSingleSelectedMeter,
  props<{ singleSelectedMeter: any }>(),
);

export const getMeterFilterOptions = createAction(
  SelectMetersActionType.getMeterFilterOptions,
);
export const getMeterFilterOptionsSuccess = createAction(
  SelectMetersActionType.getMeterFilterOptionsSuccess,
  props<{ filterOptions: any }>(),
);

export const setSelectMeterComponentFilters = createAction(
  SelectMetersActionType.setSelectMeterComponentFilters,
  props<{ filters: any }>(),
);

export const setSelectedMetersWithFactor = createAction(
  SelectMetersActionType.setSelectedMetersWithFactor,
  props<{ selectedMetersWithFactor: IVirtualMeterChildMeter[] }>(),
);
